import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface CupState {
  competitionId: number | null;
  cupModal: boolean;
}

const initialState: CupState = {
  competitionId: null,
  cupModal: false,
};

export const cupSlice = createSlice({
  name: 'cup',
  initialState,
  reducers: {
    setCompetitionId: (state, action: PayloadAction<CupState['competitionId']>) => {
      state.competitionId = action.payload;
      state.cupModal = true;
    },

    setCupModal: (state, action: PayloadAction<CupState['cupModal']>) => {
      state.cupModal = action.payload;
      if (!action.payload) {
        state.competitionId = null;
      }
    },
  },
});

export const { setCompetitionId, setCupModal } = cupSlice.actions;

export default cupSlice.reducer;
